import { render, staticRenderFns } from "./Started.vue?vue&type=template&id=01ebe10f&scoped=true&"
import script from "./Started.vue?vue&type=script&lang=js&"
export * from "./Started.vue?vue&type=script&lang=js&"
import style0 from "./Started.vue?vue&type=style&index=0&id=01ebe10f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ebe10f",
  null
  
)

export default component.exports